import Swiper, { Navigation, Autoplay } from "swiper";
Swiper.use([Navigation, Autoplay]);
export default class Latest {
    constructor() {
        this.initSlider();
    }

    initSlider() {
        const calculateGap = () => {
            const isLandscape = window.innerWidth > window.innerHeight;
            let gap = isLandscape ? parseFloat(getComputedStyle(document.body).getPropertyValue("--grid-cell-size")) : 40;
            return gap;
        }

        const swipee = new Swiper(".swiper-latest-growth", {
            slidesPerView: 1,
            loop: true,
            roundLengths: true,
            spaceBetween: calculateGap(),
            autoplay: {
                delay: 4500,
                disableOnInteraction: true,
            },
            navigation: {
                nextEl: ".swiper-latest-growth .swiper-button-next",
                prevEl: ".swiper-latest-growth .swiper-button-prev",
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 2,
                },
                1100: {
                    slidesPerView: 4,
                },
            },
        });
    }
}
